// A carriable good: a small olive army ration crate with a stencilled
// hazard-yellow band around its middle and a battered tin cup sitting on the
// lid. Authored about its own origin at "held" scale (matching wood-bundle /
// grain-sack), so it drops straight into a carry socket on the player or
// worker avatar via `bakeSockets`.
import * as THREE from "three";
import { defineModel, type Part } from "../../lib";

const OLIVE = "#5f6b3c";       // crate body
const OLIVE_DARK = "#4a5430";  // corner battens / lid edge
const HAZARD = "#d9a13b";      // stencilled band
const TIN = "#e8e4da";         // the cup

export const rationCrate = defineModel({
  id: "ration-crate",
  batchId: "wwi",
  name: "Ration Crate",
  tags: ["good", "carriable", "cargo", "food", "wwi"],
  fits: ["carry"],
  summary: "An olive army ration crate with a hazard-yellow band — a carriable good.",
  description:
    "A small olive wooden ration crate at held scale, banded with a " +
    "stencilled hazard-yellow stripe, corner battens and a tin cup resting on " +
    "the lid. Mount it in a player's or worker's `carry` socket to show the " +
    "figure hauling rations up the line.",
  author: "Fable 5",
  footprint: 0.09,
  parts: (): Part[] => [
    // the crate body
    { geometry: new THREE.BoxGeometry(0.115, 0.075, 0.09), color: OLIVE, position: [0, 0.0375, 0] },
    // stencilled hazard band wrapping the middle, slightly proud
    { geometry: new THREE.BoxGeometry(0.118, 0.02, 0.093), color: HAZARD, position: [0, 0.04, 0] },
    // dark corner battens on both ends
    { geometry: new THREE.BoxGeometry(0.012, 0.079, 0.094), color: OLIVE_DARK, position: [0.052, 0.0375, 0] },
    { geometry: new THREE.BoxGeometry(0.012, 0.079, 0.094), color: OLIVE_DARK, position: [-0.052, 0.0375, 0] },
    // lid plank overhanging the rim
    { geometry: new THREE.BoxGeometry(0.121, 0.01, 0.096), color: OLIVE_DARK, position: [0, 0.08, 0] },
    // battered tin cup on top: body and a stub handle
    { geometry: new THREE.CylinderGeometry(0.013, 0.011, 0.024, 7), color: TIN, position: [0.028, 0.097, 0.018] },
    { geometry: new THREE.BoxGeometry(0.005, 0.014, 0.006), color: TIN, position: [0.043, 0.097, 0.018] },
  ],
  animations: [],
});
